/*
 * Several enum members intentionally share the same string value (e.g. mandate* variants)
 * to allow mapping different domain keys to a common display label.
 */
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum FiltersKeyLabelEnum {
  statuses = 'Status',
  countries = 'Geography',
  assetTypes = 'Asset Type',
  loanTypes = 'Loan Type',
  mandateTypes = 'Mandate Type',
  strategies = 'Strategies',
  dates = 'Closing dates',
  companyTypes = 'Company Type',
  mandateCountries = 'Geography',
  mandateAssetTypes = 'Asset Type',
  mandateStrategies = 'Strategies',
  mandateLoanTypes = 'Loan Type',
}
